export default __webpack_public_path__ + "images/0xc165d941481e68696f43ee6e99bfb2b23e0e3114.png";